import { InjectionToken, Injector, Type, FactoryProvider } from "@angular/core";
import { Controller } from "./controller.interface";

export class ControllerFactory {
    static createController<T extends Controller>(type: InjectionToken<any> | string | Type<any>, injector: Injector,
        controllers?: FactoryProvider[]): { controllerName: string, controller: T } {
        if (!type)
            type = controllers[0].provide;

        if (typeof type === 'string') {
            if (!controllers)
                throw new Error("requires controllers when using type string");

            type = controllers.find(x => x.provide['_desc'] === type).provide;
            if (!type)
                throw new Error("type not found");
        }

        return { controllerName: type['_desc'], controller:injector.get(type) };
    }

    static getControllerTypes(controllers: FactoryProvider[]): string[] {
        let list: string[] = [];

        if (!controllers)
            return list;

        for (let con of controllers) {            
            list.push(con.provide['_desc']);
        }

        return list;
    }
}